import styled, { css } from 'styled-components/macro';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';

const ButtonCss = css`
  color: #861657;
  display: inline-block;
  border-color: #861657;
  border-radius: 3px;
  padding: 8px 12px;
  background: transparent;
  border: 2px solid;
  font-size: 14px;
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;

  :hover {
    color: ${() => (!isMobile ? '#93e1d8' : '')};
  }

  :active {
    color: #93e1d8;
  }

  @media (max-height: 540px) {
    font-size: ${() => (isMobile ? '12px' : '')};
  }

  @media (max-height: 440px) {
    font-size: ${() => (isMobile ? '14px' : '')};
  }
`;

const ButtonInvertedCss = css`
  ${ButtonCss}
  border-color: #93e1d8;
  color: #93e1d8;

  :hover {
    color: ${() => (!isMobile ? '#861657' : '')};
    border-color: ${() => (!isMobile ? '#861657' : '')};
  }

  :active {
    color: #861657;
    border-color: #861657;
  }
`;

export const Button = styled.a`
  ${ButtonCss}
`;

export const ButtonNoBorder = styled.a`
  ${ButtonCss}
  border-style: none;
  font-size: 17px;
  padding:0;
`;

export const ButtonLink = styled(Link)`
  ${ButtonCss}
`;

export const ButtonInverted = styled.a`
  ${ButtonInvertedCss}
`;

export const ButtonInvertedLink = styled(Link)`
  ${ButtonInvertedCss}
`;
